// @flow
import React from 'react';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
    root: {
        display: 'inline-block',
        width: '0.6em',
        height: '0.6em',
        borderRadius: '50%',
        marginRight: '1ch',
    },
    color_gray: {
        backgroundColor: '#D8D8D8'
    },
    color_green: {
        backgroundColor: '#7FD321'
    },
    color_yellow: {
        backgroundColor: '#F8E71C'
    },
    color_red: {
        backgroundColor: '#D0021A'
    },
    color_blue: {
        backgroundColor: '#4CAAEF'
    }
});

export type Props = $ReadOnly<{
    active?: boolean,
    color?: 'gray' | 'green' | 'yellow' | 'red' | 'blue',
    className?: string
}>;
function Dot({ active, color = 'gray', className }: Props) {
    const classes = useStyles({ active });

    return <span className={classnames(classes.root, classes[`color_${color}`], className)} />;
}

export default Dot;